import { AxiosResponse } from "axios";
import { put, call, throttle } from "redux-saga/effects";
import {
  errorRazorPayTransferOrder,
  failureRazorPayTransferOrder,
  PaymentActions,
  succesRazorPayTransferOrder,
  firstDataPaymentSuccess,
  firstDataPaymentFailure,
  stripePaymentTokenRetrievealSuccess,
  stripePaymentFailure,
  stripePaymentSuccess,
  offlinePaymentSuccess,
  offlinePaymentFailure,
  cnpDataPaymentFailure,
  cnpDataPaymentSuccess,
  tokenizeCardDetailSuccess,
  tokenizeCardDetailFailure,
  saveCardDetailSuccess,
  saveCardDetailFailure,
  saveCardDetailAction,
  getCardDetailsSuccess,
  getCardDetailsFailure,
  deleteCardDetailsSuccess,
  deleteCardDetailsFailure,
  isRazorPayClicked,
} from "./PaymentActions";
import {
  razorPayTransferOrderAPI,
  catpurePaymentAPI,
  firstDataTransferOrderAPI,
  stripeInitatePaymentAPI,
  offlinePaymentAPI,
  initiatetCNPPayemnetAPI,
  tokenizeCardDetail,
  saveCardDetail,
  getCardDetails,
  deleteCardDetails,
} from "./PaymentAPI";
import {
  CNP_DATA_PAYMENT_REQUEST,
  DELETE_CARD_DETAILS_REQUEST,
  FIRST_DATA_PAYMENT_REQUEST,
  GET_CARD_DETAILS_REQUEST,
  OFFLINE_PAYMENT_REQUEST,
  RAZOR_PAY_TRANSFER_ORDER,
  SAVE_CARD_DETAILS_REQUEST,
  STRIPE_CAPTURE_PAYMENT,
  STRIPE_PAYMENT_REQUEST,
  TOKENIZE_CARD_DETAILS_REQUEST,
} from "./PaymentConstants";
import {
  CNPDataOrder,
  FirstDataOrder,
  RazorPayTransferOrder,
  RazorPayTransferredOrder,
  StripeCapturePaymentPayload,
  StripeInitiatePaymentPayload,
} from "./PaymentModels";
import { decryptJson } from "../../utils/react-ec-utils";
import { showErrorToast, showErrorToastDesktop } from "../../utils/toastUtils";

function* razorPayTransferOrderSaga(action: any) {
  try {
    const isMobile = window.innerWidth <= 768;

    const response: AxiosResponse = yield call(
      razorPayTransferOrderAPI,
      action.payload
    );

    if (response.status === 200) {
      const decryptdata = decryptJson(response?.data?.encryptedText);
      yield put(
        succesRazorPayTransferOrder(decryptdata as RazorPayTransferredOrder)
      );
      yield put(isRazorPayClicked(false));
    } else {
      if(isMobile){
        showErrorToast(response?.data?.message)
      }else{
        showErrorToastDesktop(response?.data?.message)
      }
      yield put(isRazorPayClicked(false));
      yield put(
        failureRazorPayTransferOrder({
          message: response?.data?.message,
        })
      );
    }
  } catch (err) {
    const isMobile = window.innerWidth <= 768;
    yield put(isRazorPayClicked(false));
    if(isMobile){
      showErrorToast("Something went wrong!")
    }else{
      showErrorToastDesktop("Something went wrong!")
    }
    yield put(errorRazorPayTransferOrder("Please Try Again"));
  }
}

function* firstDataPaymentSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(
      firstDataTransferOrderAPI,
      action.payload as FirstDataOrder
    );

    const decryptedData = decryptJson(response?.data?.encryptedText);
    if (response.status === 200 && decryptedData.paymentStatus === "18") {
      let reqBody = action.payload;
      reqBody.token = decryptedData.paymentTransactionTokenId;
      const paymentResponse: AxiosResponse = yield call(
        catpurePaymentAPI,
        action.payload as any
      );
      const decryptdata = decryptJson(paymentResponse?.data?.encryptedText);
      if (
        paymentResponse.status === 200 &&
        decryptdata.paymentStatus === "19"
      ) {
        yield put(firstDataPaymentSuccess());
      } else {
        yield put(firstDataPaymentFailure());
      }
    } else {
      yield put(firstDataPaymentFailure());
    }
  } catch (err) {
    console.error(err);
  }
}

function* stripeInitiatePaymentSaga(action: any) {
  try {
    const paymentResponse: AxiosResponse = yield call(
      stripeInitatePaymentAPI,
      action.payload as StripeInitiatePaymentPayload
    );
    if (
      paymentResponse.status === 200 &&
      paymentResponse.data.paymentStatus === "18"
    ) {
      yield put(
        stripePaymentTokenRetrievealSuccess(
          paymentResponse.data.paymentTransactionId
        )
      );
    } else {
      yield put(stripePaymentFailure());
    }
  } catch (err) {
    console.error(err);
  }
}

function* offlinePaymentSaga(action: any) {
  try {
    let callBackFunc = null;
    if (
      action.payload?.sagaCallBack != null &&
      typeof action.payload?.sagaCallBack === "function"
    ) {
      callBackFunc = action.payload?.sagaCallBack;
      delete action.payload?.sagaCallBack;
    }
    const paymentResponse: AxiosResponse = yield call(
      offlinePaymentAPI,
      action.payload as any
    );

    const decryptedData = decryptJson(paymentResponse?.data?.encryptedText);
    if (paymentResponse.status === 200) {
      yield put(offlinePaymentSuccess(decryptedData));
      if (callBackFunc != null) {
        callBackFunc(true);
      }
    } else {
      yield put(offlinePaymentFailure("Offline Payment Failed"));
      if (callBackFunc != null) {
        callBackFunc(false);
      }
    }
  } catch (err) {
    console.error(err);
  }
}

function* stripeCapturePaymentSaga(action: any) {
  try {
    const paymentResponse: AxiosResponse = yield call(
      catpurePaymentAPI,
      action.payload as StripeCapturePaymentPayload
    );
    if (
      paymentResponse.status === 200 &&
      paymentResponse.data.paymentStatus === "19"
    ) {
      yield put(stripePaymentSuccess());
    } else {
      yield put(stripePaymentFailure());
    }
  } catch (err) {
    console.error(err);
  }
}

function* cnpDataPaymentSaga(action: any) {
  let initiatePaymentRequest = action.payload as CNPDataOrder;

  try {
    const initiatePaymentResponse: AxiosResponse = yield call(
      initiatetCNPPayemnetAPI,
      initiatePaymentRequest
    );

    if (initiatePaymentResponse.status === 200) {
      const decryptedData = decryptJson(
        initiatePaymentResponse?.data?.encryptedText
      );
      if (
        initiatePaymentResponse.status === 200 &&
        decryptedData.paymentStatus === "19"
      ) {
        yield put(cnpDataPaymentSuccess());
        if (
          initiatePaymentRequest?.sagaCallBack != null &&
          typeof initiatePaymentRequest?.sagaCallBack === "function"
        ) {
          initiatePaymentRequest.sagaCallBack(true);
        }
      } else {
        yield put(cnpDataPaymentFailure(decryptedData.message));
        if (
          initiatePaymentRequest?.sagaCallBack != null &&
          typeof initiatePaymentRequest?.sagaCallBack === "function"
        ) {
          initiatePaymentRequest.sagaCallBack(false);
        }
      }
    } else {
      yield put(cnpDataPaymentFailure(initiatePaymentResponse.data));
      if (
        initiatePaymentRequest?.sagaCallBack != null &&
        typeof initiatePaymentRequest?.sagaCallBack === "function"
      ) {
        initiatePaymentRequest.sagaCallBack(false);
      }
    }
  } catch (err) {
    console.error({ err });
    const errorMessage = (err as Error).message || "Unknown error occurred";

    yield put(cnpDataPaymentFailure(errorMessage));
    if (
      initiatePaymentRequest?.sagaCallBack != null &&
      typeof initiatePaymentRequest?.sagaCallBack === "function"
    ) {
      initiatePaymentRequest.sagaCallBack(false);
    }
  }
}

function* tokenizeCardDetailSaga(action: any) {
  let sagaCallBack = null;
  let saveCardSagaCallBack = null;
  if (action.payload?.sagaCallBack !== null) {
    sagaCallBack = action.payload?.sagaCallBack;
    delete action.payload.sagaCallBack;
  }
  if (action.payload?.saveCardSagaCallBack !== null) {
    saveCardSagaCallBack = action.payload?.saveCardSagaCallBack;
    delete action.payload.saveCardSagaCallBack;
  }
  try {
    const cardSaveResponse: AxiosResponse = yield call(
      tokenizeCardDetail,
      action.payload
    );

    if (cardSaveResponse.status === 200) {
      yield put(tokenizeCardDetailSuccess(cardSaveResponse?.data));
      yield put(
        saveCardDetailAction({
          locationId: action.payload?.locationId,
          customerId: action.payload?.customerId,
          cvv: action.payload?.cvv,
          cardType: cardSaveResponse?.data?.Brand,
          expiryMonth: cardSaveResponse?.data?.ExpirationMonth,
          expiryYear: cardSaveResponse?.data?.ExpirationYear,
          // cardToken: cardSaveResponse?.data?.Token,
          lastFourDigits: cardSaveResponse?.data?.Last4,
          account: action.payload?.account,
          zipcode: action.payload?.zipcode,
          streetNo: action.payload?.streetNo,
          sagaCallBack: saveCardSagaCallBack ?? undefined,
        })
      );
    } else {
      sagaCallBack(false, action.payload);     
      yield put(tokenizeCardDetailFailure());
    }
  } catch (err) {
    sagaCallBack(false, action.payload);
     yield put(tokenizeCardDetailFailure());
    console.error(err);
  }
}

function* saveCardDetailSaga(action: any) {
  const isMobile = window.innerWidth <= 768;

  const sagaCallBack = action.payload?.sagaCallBack ?? null;
  try {
    if (sagaCallBack != null && typeof sagaCallBack === "function") {
      delete action.payload.sagaCallBack;
    }
    const cardSaveResponse: AxiosResponse = yield call(
      saveCardDetail,
      action.payload
    );

    if (cardSaveResponse.status === 200) {
      if (sagaCallBack) {
        sagaCallBack(true);
      }
      yield put(saveCardDetailSuccess(cardSaveResponse?.data));
    } else {
      if (sagaCallBack) {
        sagaCallBack(false);
      }
      if(!sagaCallBack){
        if(isMobile){
          showErrorToast("Invalid Card Details")
        }else{
          showErrorToastDesktop("Invalid Card Details")
        }
      }
      yield put(saveCardDetailFailure());
    }
  } catch (err: any) {
    if(!sagaCallBack){
      if(isMobile){
        showErrorToast('Something went wrong !')
      }else{
        showErrorToastDesktop('Something went wrong !')
      }
    }
    sagaCallBack(false);
    console.error(err);
  }
}

function* getCardDetailsSaga(action: any) {
  try {
    const cardSaveResponse: AxiosResponse = yield call(
      getCardDetails,
      action.payload
    );
    // const decryptedData = decryptJson(cardSaveResponse?.data?.encryptedText);
    if (cardSaveResponse.status === 200) {
      yield put(getCardDetailsSuccess(cardSaveResponse?.data));
    } else {
      yield put(getCardDetailsFailure(cardSaveResponse?.data));
    }
  } catch (err) {
    console.error(err);
  }
}

function* deleteCardDetailsSaga(action: any) {
  try {
    const cardSaveResponse: AxiosResponse = yield call(
      deleteCardDetails,
      action.payload.cardId
    );
    // const decryptedData = decryptJson(cardSaveResponse?.data?.encryptedText);
    if (cardSaveResponse.status === 200) {
      yield put(deleteCardDetailsSuccess(cardSaveResponse?.data));
      const customerId  = action.payload.customerId;
      if (customerId) {
        yield put({
          type: GET_CARD_DETAILS_REQUEST,
          payload: customerId ,
        });
      }

    } else {
      yield put(deleteCardDetailsFailure(cardSaveResponse?.data));
    }
  } catch (err) {
    console.error(err);
  }
}
export default function* paymentSaga() {
  yield throttle(3000, RAZOR_PAY_TRANSFER_ORDER, razorPayTransferOrderSaga);
  yield throttle(3000, TOKENIZE_CARD_DETAILS_REQUEST, tokenizeCardDetailSaga);
  yield throttle(3000, SAVE_CARD_DETAILS_REQUEST, saveCardDetailSaga);
  yield throttle(3000, FIRST_DATA_PAYMENT_REQUEST, firstDataPaymentSaga);
  yield throttle(3000, STRIPE_PAYMENT_REQUEST, stripeInitiatePaymentSaga);
  yield throttle(3000, STRIPE_CAPTURE_PAYMENT, stripeCapturePaymentSaga);
  yield throttle(3000, OFFLINE_PAYMENT_REQUEST, offlinePaymentSaga);
  yield throttle(3000, CNP_DATA_PAYMENT_REQUEST, cnpDataPaymentSaga);
  yield throttle(100, GET_CARD_DETAILS_REQUEST, getCardDetailsSaga);
  yield throttle(100, DELETE_CARD_DETAILS_REQUEST, deleteCardDetailsSaga);
}
